import { APP_VERSION } from "@/lib/version";

export function Footer() {
  return (
    <footer className="border-t border-gray-100 px-6 py-4 text-center text-xs text-gray-400 sm:px-8">
      © {new Date().getFullYear()} Hormuud · SMS Gateway Admin
      <span className="mx-1.5 text-gray-300">·</span>
      <span className="font-medium text-gray-500">v{APP_VERSION}</span>
    </footer>
  );
}
